import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { TableRowType } from "../../../main/components/RopTable/RopTable";
import ListScreen from "../../../main/components/ListScreen";
import { Client } from "../types";
import { clientsApi } from "../../../services/api";

export default function ClientsList() {
  const [loading, setLoading] = useState(true);
  const [clients, setClients] = useState<Client[]>([]);
  const [pageIndex, setPageIndex] = useState(0);
  const page = pageIndex + 1;

  const navigate = useNavigate();

  useEffect(() => {
    mount();
  }, [
    pageIndex,
    ,
    // search
    25,
  ]);
  const mount = async () => {
    try {
      setLoading(true);
      const response = await clientsApi.getClients
        // page, search, undefined, 25
        ();
      if (response.total < page * 25) {
        setPageIndex(0);
      }
      setClients(response.data);
      //setClientsAmount(response.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const tableRows: TableRowType[] = clients.map((e) => ({
    rowItems: [
      {
        item: e.name,
        isMobile: true,
      },
      {
        item: e.usinasIds?.length ?? 0,
        align: "center",
        isMobile: true,
      },
      {
        item: e.collaboratorsList?.length ?? 0,
        align: "center",
      },
    ],
    onClick: () => {
      navigate(e.id);
    },
  }));

  return (
    <ListScreen
      buttonTilte="Adicionar Cliente"
      title="Clientes"
      onClick={() => {
        navigate("cadastrar");
      }}
      hover
      isLoading={loading}
      itemsHeaders={[
        {
          item: "Nome",
          isMobile: true,
        },
        {
          item: "N° de Usinas",
          align: "center",
          isMobile: true,
        },
        {
          item: "N° de Colaboradores",
          align: "center",
        },
      ]}
      itemRows={tableRows}
    />
  );
}
